import { navStepAtom, productKeyAtom } from "src/atoms";
import { useRecoilState } from "recoil";
import WrapsodyAndEcoSitePromotion from "./WrapsodyAndEco/PromotionWrapsodyAndEco.container";
import { useEffect } from "react";

const SitePromotionContainer = () => {
  const [product, setProduct] = useRecoilState(productKeyAtom);
  const [navStep, setNavStep] = useRecoilState(navStepAtom);
  useEffect(() => {
    setNavStep(2);
  }, []);
  // OCI제품 전용 UI
  if (["WRAPSODY", "WRAPSODY_ECO"].includes(product)) {
    return <WrapsodyAndEcoSitePromotion />;
  }
};

export default SitePromotionContainer;
